import * as e from "react";
import { forwardRef as l } from "react";
const i = l(
  function(t, r) {
    return /* @__PURE__ */ e.createElement(
      "svg",
      {
        fill: "none",
        ref: r,
        viewBox: "0 0 25 24",
        xmlns: "http://www.w3.org/2000/svg",
        ...t
      },
      /* @__PURE__ */ e.createElement("g", null, /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M9.45833 16.4166H2M9.45833 16.4166L7.97518 18.3731C7.67585 18.768 7.20892 19 6.71342 19H4.5M9.45833 16.4166L11.4792 14.4583L13.3233 12.6713C13.4213 12.5762 13.5775 12.5775 13.674 12.674L14.75 13.75L15.8667 14.8667C15.9456 14.9456 16.0673 14.9626 16.1648 14.9084L20.5 12.5",
          stroke: "#000",
          strokeLinecap: "round",
          strokeWidth: 2
        }
      ), /* @__PURE__ */ e.createElement("circle", { cx: 13.375, cy: 8.375, fill: "#000", r: 2.375 }), /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M19.9281 7.9699C20.0433 7.70383 21.2125 7.19906 22.2 7.62669C23.1875 8.05431 23.6654 9.14596 23.5041 9.51846C23.3428 9.89096 22.2196 10.2893 21.2321 9.86168C20.6454 9.60759 20.2548 9.08146 20.0586 8.64048L20.0313 8.5766C19.9189 8.30276 19.8847 8.07016 19.9281 7.9699Z",
          fill: "#000",
          stroke: "#000",
          strokeWidth: 0.626807
        }
      ), /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M15.2929 10.2929L14.5858 11L16 12.4142L16.7071 11.7071L15.2929 10.2929ZM18.7071 9.70711C19.0976 9.31658 19.0976 8.68342 18.7071 8.29289C18.3166 7.90237 17.6834 7.90237 17.2929 8.29289L18.7071 9.70711ZM16 11L16.7071 11.7071L18.7071 9.70711L18 9L17.2929 8.29289L15.2929 10.2929L16 11Z",
          fill: "#000"
        }
      )),
      /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement("clipPath", null, /* @__PURE__ */ e.createElement(
        "rect",
        {
          fill: "#fff",
          height: 15,
          transform: "translate(1 5)",
          width: 24
        }
      )))
    );
  }
);
export {
  i as BetBuilderBadgeAmericanReceiving
};
